import { createSlice } from "@reduxjs/toolkit";
import { CreateAppData } from "../types/CreateAppType";
import { getCinFromPanAction } from "../action/getCinFromPanAction";

const initialState: CreateAppData = {
  data: null,
  loading: false,
  error: null,
};

const cinFromPanSlice = createSlice({
  name: "cinFromPanSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCinFromPanAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCinFromPanAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getCinFromPanAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const cinFromPanReducer = cinFromPanSlice.reducer;
